import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8'];

const FaqSection = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
    requestAnimationFrame(() => AOS.refresh());
  };

  return (
    <section id="faq" className="section-x faq">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mx-auto text-center mb-5">
            <div className="eyebrow eyebrow--center mb-3" data-aos="fade-up">
              <span>{t('faq.eyebrow')}</span>
            </div>
            <h2 className="section-heading" data-aos="fade-up">
              {t('faq.titleLead')}{' '}
              <span className="gold-text">{t('faq.titleHighlight')}</span>
            </h2>
            <p className="section-subheading" data-aos="fade-up" data-aos-delay="80">
              {t('faq.subtitle')}
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-9 mx-auto">
            <div className="faq-list">
              {FAQ_KEYS.map((key, i) => {
                const isOpen = openIndex === i;
                const panelId = `faq-panel-${i}`;
                return (
                  <div
                    key={key}
                    className={`faq-item ${isOpen ? 'is-open' : ''}`}
                    data-aos="fade-up"
                    data-aos-delay={i * 40}
                  >
                    <button
                      type="button"
                      className="faq-item__q"
                      onClick={() => toggle(i)}
                      aria-expanded={isOpen}
                      aria-controls={panelId}
                    >
                      <span className="faq-item__q-num mono">0{i + 1}</span>
                      <span className="faq-item__q-text">{t(`faq.${key}.question`)}</span>
                      <span className="faq-item__q-icon" aria-hidden="true">
                        <i className={`fas ${isOpen ? 'fa-minus' : 'fa-plus'}`} />
                      </span>
                    </button>
                    <div
                      id={panelId}
                      className="faq-item__a-wrap"
                      role="region"
                      aria-hidden={!isOpen}
                    >
                      <div className="faq-item__a">{t(`faq.${key}.answer`)}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
